import React from 'react';
import styles from 'routes/adminMobile/components/AdminMobileStoreSaleStat.module.css';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { mainPadd2, pageEH2FontSize, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';
import { useNavigate } from 'react-router-dom';

const AdminMobileStoreSaleStat = ({storeData}) => {
    const navigate = useNavigate();
    

    if (!storeData || storeData.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    const handleStoreClick = (store) => {
        
        

        // 상세 페이지로 이동하면서 데이터 전달
        navigate(`/admin/mobile/statsDetail/${store.store.storeNo}`, { state: { storeData: store } });
    };

    return (
        <AdminMobileContentBox>
            <VerticalFlex>
                <FlexChild>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex>
                            <FlexChild>
                                <P size={pageEH2FontSize}>지점별 판매량</P>
                            </FlexChild>
                            <FlexChild justifyContent="flex-end">
                                <img className={styles.moveIcon} src={backIcon} alt='이동 아이콘' />
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
                <FlexChild>
                    <VerticalFlex gap={registerGap2}>
                        <FlexChild>
                        {/* 반복 구간 */}
                        {storeData && storeData.map((store, index) => (
                            <div key={index} className={styles.listMoveClick} onClick={() => handleStoreClick(store)}>
                                <FlexChild height="initial">
                                    <VerticalFlex gap={registerGap2}>
                                        <FlexChild>
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={pageEH3FontSize} weight={700}>대전 {store.store.storeName}</P>
                                                </FlexChild>
                                                <FlexChild justifyContent="flex-end">
                                                    <P size={pageEH3FontSize} weight={700}>
                                                        {store.totalSales ? store.totalSales.toLocaleString() : 0}
                                                    </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                        <FlexChild alignItems="flex-end">
                                            <P size={pageEH3FontSize}>
                                                ( {store.totalQuantity ? store.totalQuantity.toLocaleString() : 0} 개 판매 )
                                            </P>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </div>
                        ))}
                        {/* 반복 구간 */}
                        </FlexChild>
                    </VerticalFlex>
                </FlexChild>
            </VerticalFlex>
        </AdminMobileContentBox>
    );
};

export default AdminMobileStoreSaleStat;